<template>
    <div class="frame-view">
        <iframe v-if="canLoad" id="view-frame" ref="frame" :srcdoc="srcdoc" />
        <div v-if="loading" class="spinner">
            <md-progress-spinner md-mode="indeterminate" />
        </div>
    </div>
</template>

<script>
import mustache from 'mustache';

/* eslint-disable no-useless-escape */
const customPageHeightResetTemplate = `<script>
        var customPageZeroReset = true,
        customPageHeightReset = false,
        customPageHeightTimeout = undefined,
        customPageBody = document.body,
        customPageHtml = document.documentElement;

        var reportHeight = function(event) {

            clearTimeout(customPageHeightTimeout);
            customPageHeightTimeout = setTimeout(function() {
                var height = Math.max( customPageBody.scrollHeight, customPageBody.offsetHeight,
                                    customPageHtml.clientHeight, customPageHtml.scrollHeight, customPageHtml.offsetHeight );

                if(customPageHtml.clientHeight > 0 && !customPageZeroReset && !customPageHeightReset) {
                        window.parent.postMessage({
                            'height': 0
                        }, "{{{baseURL}}}");
                        customPageZeroReset = true;
                        return;
                } else if(!customPageHeightReset && customPageZeroReset) {
                        window.parent.postMessage({
                            'height': height
                        }, "{{{baseURL}}}");
                        customPageHeightReset = true;

                } else {
                    customPageHeightReset = false;
                    customPageZeroReset = false;
                }
            },100);
        }
        window.addEventListener('resize', reportHeight, true);
        window.addEventListener('load', reportHeight, true);
    <\/script>`;

export default {
    name: 'FrameView',
    props: {
        pageId: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        srcdoc: undefined,
        canLoad: false,
        loading: false,

        // Used to handle the case where the assigned page ID is changed by
        // user interaction before the prior page was loaded.
        serial: 0,
    }),
    watch: {
        pageId() {
            this.updatePage();
        },
    },
    created() {
        this.updatePage();
        global.addEventListener('message', this.onMessage, false);
    },
    beforeDestroy() {
        global.removeEventListener('message', this.onMessage);
    },
    methods: {
        onMessage(e) {
            if (e.origin !== global.location.origin) {
                return;
            }
            this.setHeight(e.data?.height);
        },
        setHeight(height) {
            if (this.$refs?.frame && height >= 0) {
                this.$refs?.frame?.setAttribute(
                    'style',
                    `height: ${height + 25}px`,
                );
            }
        },
        async updatePage() {
            this.serial += 1;

            this.srcdoc = undefined;
            this.canLoad = false;

            if (this.pageId === undefined || this.pageId === '') {
                this.loading = false;
                return;
            }

            this.loading = true;
            const opSerial = this.serial;

            try {
                const [template, settings] = await Promise.all([
                    this.$gideo.getPageContent(this.pageId),
                    this.$appSettings,
                ]);

                if (this.serial === opSerial) {
                    const html = mustache.render(
                        template,
                        {
                            settings,
                            baseURL: global.location.href,
                        },
                        {
                            scripts: customPageHeightResetTemplate,
                        },
                    );

                    this.srcdoc = html;
                    this.canLoad = true;
                    this.loading = false;
                }
            } catch (err) {
                this.$router.replace({
                    name: 'PageNotFound',
                    params: [this.$route.path],
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#view-frame {
    width: 100%;
    height: calc(100vh - 13rem);
    border: none;
}
</style>
